<template>
  <table class="table table-atendimento">
    <thead>
      <tr>
        <th scope="col">Posição</th>
        <th scope="col">Vendedor</th>
        <th scope="col">Tipo Vendedor</th>
        <th scope="col">Ações</th>
      </tr>
    </thead>

    <draggable
      v-model="internalUsuarios"
      tag="tbody"
      item-key="id"
      group="vendedores"
      @end="onDragEnd"
    >
      <template #item="{ element, index }">
        <tr
          :class="[
            'table-linha',
            'draggable-row',
            getStatusClass(element),
            { 'table-active': isDragging && currentDrag === element.id },
          ]"
        >
          <td>☰ {{ index + 1 }}</td>
          <!-- Removida a classe handle -->
          <td>{{ element.vendedor.username }}</td>
          <td>
            {{
              element.vendedor.tipo_vend[0]?.tipo_vendedor === 1
                ? "Novo"
                : element.vendedor.tipo_vend[0]?.tipo_vendedor === 2
                ? "Usado"
                : element.vendedor.tipo_vend[0]?.tipo_vendedor === 3
                ? "Ambos"
                : "Não definido"
            }}
          </td>
          <td>
            <!-- <button
              type="button"
              class="btn-desk"
              @click="pausar_vendedor(element.id)"
            >
              <i class="bi bi-pencil"></i>
            </button> -->
          </td>
        </tr>
      </template>
    </draggable>
  </table>
</template>

<script>
import { ref, watch } from "vue";
import draggable from "vuedraggable";
import axios from "axios";

export default {
  components: { draggable },
  props: {
    usuarios: {
      type: Array,
      required: true,
      validator: (value) =>
        Array.isArray(value) && value.every((item) => "id" in item),
    },
  },
  emits: ["update:usuarios", "reordenado"],
  setup(props, { emit }) {
    const internalUsuarios = ref([...props.usuarios]);
    const isDragging = ref(false);
    const currentDrag = ref(null);

    watch(
      () => props.usuarios,
      (newVal) => {
        internalUsuarios.value = [...newVal];
      }
    );

    const onDragEnd = () => {
      isDragging.value = false;
      currentDrag.value = null;
      emit("update:usuarios", internalUsuarios.value);
      emit("reordenado", internalUsuarios.value);
    };

    const getStatusClass = (item) => {
      console.log("Status", item);
      if (!item?.status) return "";
      return {
        "table-success": item.status.includes("disponivel"),
        "table-warning": item.status.includes("indisponivel"),
        "table-danger": item.status.includes("Bloqueado"),
      };
    };

    const editItem = (item) => {
      console.log("Editar:", item);
    };

    const deleteItem = (id) => {
      console.log("Deletar:", id);
    };
   const pausar_vendedor = async (vendedorId) => {
  try {
    const confirmar = window.confirm('Deseja realmente pausar este vendedor?');
    if (!confirmar) return;

    const response = await axios.put(
      `${process.env.VUE_APP_API_URL}pausar/${vendedorId}`,
      {
        liberado_gerente: 3
      }
    );

    // Atualiza o status localmente
    const index = internalUsuarios.value.findIndex(u => u.id === vendedorId);
    if (index !== -1) {
      internalUsuarios.value[index].liberado_gerente = 3;
      internalUsuarios.value[index].status = 'indisponivel';
      emit('update:usuarios', [...internalUsuarios.value]);
    }
    if(response.data.success == true){
      console.log('Vendedor pausado com sucesso:', response.data);
      window.confirm(response.data.message);
      window.location.reload();
    }
    
  } catch (error) {
    console.error('Erro ao pausar vendedor:', error);
    // Tratamento de erro (ex: mostrar mensagem para o usuário)
  }
};

    return {
      internalUsuarios,
      isDragging,
      currentDrag,
      onDragEnd,
      getStatusClass,
      editItem,
      deleteItem,
      pausar_vendedor,
    };
  },
};
</script>

<style scoped>
.sortable-ghost {
  opacity: 0.7;
  background: #e9ecef;
}

.sortable-chosen {
  background-color: #f8f9fa;
}

.table-active {
  background-color: rgba(0, 123, 255, 0.1) !important;
}

/* Estilo para toda a linha arrastável */
.draggable-row {
  cursor: move;
  user-select: none;
}

/* Opcional: destaque ao arrastar */
.draggable-row:active {
  cursor: grabbing;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.table-linha {
  transition: all 0.3s ease;
}

/* Prevenir seleção de texto durante o arraste */
.table-linha * {
  user-select: none;
  -webkit-user-select: none;
}
</style>
